import apiClient from '../../config/axios';

export const cashPaymentService = {
  /**
   * Creates a cash payment membership
   * @param {Object} user - The current user object
   * @param {Object} membershipData - The membership data
   * @returns {Promise<Object>} - Response with success status and data or error
   */
  createCashMembership: async (user, {membershipListId}) => {
    try {
      if (!user || !user._id) {
        return {
          success: false,
          error: 'Utente non autenticato.',
        };
      }

      const response = await apiClient.post('/api/memberships', {membershipListId});
      
      return {
        success: true,
        membership: response.data,
        message: 'Membership creata con successo',
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Errore nella creazione della membership in contanti',
      };
    }
  },

 
  // updateUserWithMembership: (user, newMembership, updateUser) => {
  //   updateUser({ 
  //     ...user, 
  //     memberships: [...user.memberships, newMembership] 
  //   });
  // },
}; 